<nz-card
  [nzTitle]="cardTitle"
  [nzSize]="wrapperOptions.size ?? 'default'"
  [nzExtra]="operatorSelector"
  [nzActions]="[actionSearch]"
  class="large-card"
  [cvcAutoHeightCard]="4"
  cvcAutoHeightTarget="ancestor"
  cvcAutoHeightAncestor=".query-form-content">
  @if (subFiltersField) {
    <formly-field [field]="subFiltersField"></formly-field>
  } @else {
    <span style="color: red">No subfilters field found</span>
  }
</nz-card>
<ng-template #cardTitle>
  @let config = getSearchConfig(wrapperOptions.searchEndpoint!);
  @if (config) {
    <nz-icon
      [nzType]="config.icon"
      nzTheme="twotone"
      [nzTwotoneColor]="config.iconColor" />
  }

  {{ wrapperOptions.title }}
</ng-template>
<ng-template #actionSearch>
  <nz-row
    [nzGutter]="[8, 8]"
    class="form-actions">
    <nz-col nzSpan="4">
      <button
        nz-button
        nzBlock
        nzType="default"
        nzSize="default"
        (click)="onClearForm()">
        Clear Filters
      </button>
    </nz-col>

    <nz-col
      nzSpan="12"
      class="form-messages">
      @if (formSubmitted && hasNoFilters) {
        <span class="error-msg">Add at least one filter before searching.</span>
      } @else if (isFormInvalid) {
        <span class="error-msg"
          >Please complete all filter values before searching.</span
        >
      }
    </nz-col>
    <nz-col nzSpan="8">
      <button
        nz-button
        nzBlock
        nzType="primary"
        nzSize="default"
        (click)="onSubmitQuery()">
        Search
      </button>
    </nz-col>
  </nz-row>
</ng-template>

<ng-template #operatorSelector>
  @if (operatorField) {
    <nz-space nzSize="small">
      <span *nzSpaceItem>Match</span>
      <formly-field
        *nzSpaceItem
        [field]="operatorField"></formly-field>
      <span *nzSpaceItem>of the following conditions</span>
    </nz-space>
  }
</ng-template>
